<template>
  <div class="alerts">
    <b-alert
      v-for="(alert,index) in alerts"
      :key="alert.timestamp"
      :show="true"
      :variant="alert.variant"
      dismissible
      @dismissed="onDismissed(index)"
    >
      {{ alert.message }}
    </b-alert>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";

  export default {
    name: "AlertsComponent",
    computed: {
      ...mapGetters(['alerts'])
    },
    watch: {
      timeNowUtc: function (now) {
        for (const alert of this.alerts){
          if (alert.variant === 'success'){
            const alertTime = moment.utc(alert.timestamp);
            const duration = moment.duration(now.diff(alertTime));
            const seconds = duration.asSeconds();
            if (seconds> 10){
              this.$store.commit('REMOVE_ALERT_BY_TEXT',alert.message)
            }
          }
        }
      }
    },
    data() {
      return {
        timeNowUtc: moment.utc()
      }
    },
    created() {
      let vm = this;
      setInterval(() => {
        this.timeNowUtc = moment.utc()
      }, 1000 * 5)
    },
    methods: {
      onDismissed(index) {
        this.$store.commit('REMOVE_ALERT', index);
      }
    }
  }
</script>